/* eslint-disable */ /* tslint:disable */ import { pathgen } from 'object-path-generator';
const createProxyImpl = function createProxyImpl() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
        for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
            _tmp[_key] = arguments[_key];
        }
        let [k] = _tmp;
        return k;
    };
    return pathgen(undefined, function(path) {
        for(var _len = arguments.length, options = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            options[_key - 1] = arguments[_key];
        }
        const finalPath = path.split('.$value')[0];
        return t(finalPath, ...options);
    });
};
export function LocaleKeys(t) {
    return createProxyImpl(t);
}
